// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { generateRandomNumber } from '../../../utils/number';
import Drawer from '../../Drawer/Drawer';

import style from './DotsDrawer.scss';
import buttonsStyleAsset from '../../../assets/styles/button.scss';

import type { MenuOption } from '../DotsMenu';

type Props = {
  openMenu: boolean;
  options: MenuOption[];
  handleClickOutside: () => void;
};

export default class DotsDrawer extends Component<Props, void> {

  constructor(props: Props) {
    super(props);
  }

  buildOptionContent(option: MenuOption) {
    return (
      <FormattedMessage id={option.labelIntl}>{
        txt => <p className={classNames(
          { [style.lightBlue]: option.color === 'lightBlue' },
          { [style.orange]: option.color === 'orange' },
          { [style.red]: option.color === 'red' },
        )}>{option.icon && <i className={option.icon}/>}{txt}</p>
      }</FormattedMessage>
    );
  }

  interceptCloseOnClick(e: Event, fn?: (e: Event) => void) {
    const { handleClickOutside } = this.props;
    handleClickOutside();
    if (fn) fn(e);
  }

  render() {
    const { options, openMenu, handleClickOutside } = this.props;
    const optionsContent = options.map((option: MenuOption, n: number) => [
      <li key={`menuOption-${n}-${Date.now()}`}>
        {option.link && <Link className={classNames({ [style.disabled]: option.disabled })}
                              onClick={(e: Event) => this.interceptCloseOnClick(e)}
                              to={option.link}>{this.buildOptionContent(option)}</Link>}
        {option.handler && <button className={classNames({ [style.disabled]: option.disabled })}
                                   onClick={(e: Event) => this.interceptCloseOnClick(e, option.handler)}>
          {this.buildOptionContent(option)}
        </button>}
      </li>,
      <hr key={`menuSeparator-${n}-${Date.now()}`}
          className={style.separator}/>
    ]);
    return (
      <Drawer open={openMenu}
              direction="bottom"
              handleClickOutside={handleClickOutside}>
        <section className={style.drawerContent}>
          <ul className={style.menuWrap}>
            {optionsContent}
          </ul>
        </section>
        <footer className={style.drawerFooter}>
          <FormattedMessage id="flights.active.box.menu.cancel">{
            txt => <button type="button"
                           onClick={handleClickOutside}
                           className={classNames(buttonsStyleAsset.btn)}>{txt}</button>
          }</FormattedMessage>
        </footer>
      </Drawer>

    );
  }
}

DotsDrawer.propTypes = {
  openMenu: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  handleClickOutside: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/DotsMenu/DotsDrawer/DotsDrawer.jsx